// STEP 1: On button click – set flag before the app reloads the page
document.body.addEventListener("click", (event) => {
  const btn = event.target.closest('[data-essential-upsell-element="add-to-cart-button"]');
  if (!btn) return;

  console.log("Essential upsell clicked – setting redirect flag");

  // Save a flag that survives the reload
  sessionStorage.setItem('redirectToCartAfterReload', 'true');
});

// STEP 2: On next page load – check the flag and redirect
window.addEventListener('DOMContentLoaded', () => {
  const shouldRedirect = sessionStorage.getItem('redirectToCartAfterReload');

  if (shouldRedirect) {
    console.log("Redirect flag found – redirecting to /cart in 1s");
    sessionStorage.removeItem('redirectToCartAfterReload'); // clean up

    setTimeout(() => {
      window.location.href = '/cart';
    }, 1000); // 1 second delay after page load
  }
});